import FooterControl from '@/components/FooterControl.vue';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import { checkAmt, checkNumMust, checkNumMain } from '@/utils/validate/elementMethod';

export default {
  name: 'add-cn',
  components: { FooterControl, HisAutocompleteSuggestions },
  data() {
    return {
      state: this.$route.query.state,
      id: parseInt(this.$route.query.id, 10),
      ruleForm: {
        tempName: '', // 模板名字
        usage: '', // 用法
        adjusting: '', // 调法
        minuteNumber: '', // 时长
        count: '', // 数量
        position: '', // 部位
        retailPrice: '', // 金额
        patientStickingDrugList: [{
          drugName: '', // 药品名字
          dosage: '', // 开药量
          dosageUnit: 'g', // 开药量单位
        }],
      },
      rules: {
        tempName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' },
        ],
        usage: [
          { required: true, message: '请输入用法', trigger: 'change' },
        ],
        adjusting: [
          { required: true, message: '请输入调法', trigger: 'change' },
        ],
        minuteNumber: [
          { required: true, validator: checkNumMain, trigger: 'change' },
        ],
        count: [
          { required: true, validator: checkNumMain, trigger: 'blur' },
        ],
        retailPrice: [
          { required: true, validator: checkAmt, trigger: 'blur' },
        ],
        dosage: [
          { required: true, validator: checkNumMust, trigger: 'blur' },
        ],
      },
      position: [], // 贴敷部位
    };
  },
  methods: {
    remoteMethod(query) {
      this.getComValue(12, query);
    },
    // 删除药品
    deleteDrug(index) {
      this.ruleForm.patientStickingDrugList.splice(index, 1);
    },
    // 添加药品
    addDrug() {
      this.ruleForm.patientStickingDrugList.push({
        drugName: '', // 药品名字
        dosage: '', // 开药量
        dosageUnit: 'g', // 开药量单位
      });
    },
    goback() {
      this.$router.go(-1);
    },
    getData() {
      this.$api.clinicManagement.getStickingDrugGroupRecipe({
        templateId: this.id,
      }).then((res) => {
        const newlist = res;
        newlist.position = JSON.parse(res.position);
        this.ruleForm = newlist;
      });
    },
    // 贴敷药品输入框失焦
    stickingBlur(name, index) {
      this.ruleForm.patientStickingDrugList[index].drugName = name;
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 贴敷处方输入验证
          let isTrueStickDrug = true;
          const newList = [];
          this.ruleForm.patientStickingDrugList.forEach((it, indexs) => {
            if (it.drugName === '' && !it.dosage) return;
            const isEmpty = it.drugName === '' || it.dosage === '' || !it.dosage || it.dosage <= 0;
            if (isEmpty) {
              this.$message({
                message: '请完善贴敷处方药品信息',
                type: 'error',
              });
              this.$set(this.ruleForm.patientStickingDrugList[indexs], 'error', true);
              isTrueStickDrug = false;
            }
            newList.push(it);
          });
          if (!isTrueStickDrug) return;
          if (newList.length < 1) {
            this.$message({
              message: '请添加药品',
              type: 'error',
            });
            return;
          }
          this.ruleForm.patientStickingDrugList = newList;
          if (this.state === 'edit') {
            this.editTemplate();
          } else {
            this.addTemplate();
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
    // 编辑模板
    editTemplate() {
      this.$api.clinicManagement.updateStickingDrugGroupRecipe({
        ...this.ruleForm,
        templateId: this.id,
        tempAuthority: this.$route.query.type,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '保存成功！',
        });
        this.goback();
      });
    },
    // 添加模板
    addTemplate() {
      this.$api.clinicManagement.insertStickingDrugGroupRecipe({
        ...this.ruleForm,
        tempAuthority: this.$route.query.type,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '添加成功！',
        });
        this.goback();
      });
    },
    // 获取公共参数
    getComValue(types, query) {
      const name = query === '' || (Array.isArray(query) && query.length === 0) ? '' : query;
      this.$api.drugControl.searchDictionary({
        type: types,
        cnName: name,
      }).then((res) => {
        const list = res.dictList.map(item => ({ value: item.cnName }));
        if (res.dictList.length > 0) {
          switch (types) {
            case 12: this.position = list; // 贴敷部位
              break;
            default:
              break;
          }
        }
      });
    },
    /* 模糊搜索
    成药处方：1=用法 2=用药频率 3=单次剂量 4=开药量
    饮片处方：6=用法 2=用药频率 7=服用要求 9=备注
    输液处方：10=用法 2=用药频率 11=滴速 3=单次剂量 4=开药量
    贴敷处方：13=用法 14=调法 12=贴敷部位
    */
    queryCom(query, cb, types) {
      this.$api.drugControl.searchDictionary({
        type: types,
        cnName: query,
      }).then((res) => {
        const list = res.dictList.map(item => ({ value: item.cnName }));
        if (res.dictList.length > 0) {
          cb(list);
        } else {
          cb([]);
        }
      });
    },
    // 通用名/商品名/条形码 检索
    querySearch(queryString, cb, index) {
      this.checkDrugStick(index);
      let drugStandList = []; // 查询出的标准库药品
      this.$api.clinicManagement.namelist({
        drugName: queryString,
        drugType: 9, // 贴敷 9
        dataSource: 2, // 查询所有库(诊所库和中央库)
      }).then((res) => {
        drugStandList = res.map(item => ({
          drugName: item.drugName,
          drugType: item.drugType,
          dosage: item.drugSalePojos.length > 0 && item.drugSalePojos[0].dosage > 0 ? item.drugSalePojos[0].dosage : null,
          dosageUnit: item.drugSalePojos.length > 0 ? item.drugSalePojos[0].unitName : 'g',
          specification: item.specification, // 规格
          manufacturer: item.manufacturer, // 厂家
          drugId: item.id,
          dataSource: item.dataSource,
          inventoryCount: item.inventoryCount || 0, // 库存
          isShopDrugs: item.isShopDrugs || 0,
        }));
        cb(drugStandList);
      });
    },
    // 清空贴敷id
    checkDrugStick(index) {
      this.ruleForm.patientStickingDrugList[index].drugId = '';
    },
    // 选中药品
    handleSelectDrug(index, e) {
      // 列表禁止选择相同的药品
      const hasSameDrug = this.ruleForm.patientStickingDrugList.map(item => item.drugId).indexOf(e.drugId);
      if (hasSameDrug !== -1) {
        this.$message({
          type: 'warning',
          message: '该药已在列表中！',
        });
        return;
      }
      this.$set(this.ruleForm.patientStickingDrugList, index, e);
      // 数量为空时，光标定位到数量输入框
      this.$nextTick(() => {
        document.querySelectorAll('.dosage-input')[index].querySelector('input').focus();
      });
      // 自动添加一行
      if (index + 1 === this.ruleForm.patientStickingDrugList.length) {
        this.addDrug();
      }
    },
  },
  mounted() {
    if (this.state === 'edit') {
      this.getData();
    }
  },
};
